import { render, staticRenderFns } from "./ToolsAttributesModal.vue?vue&type=template&id=08c7be9a&"
import script from "./ToolsAttributesModal.vue?vue&type=script&lang=js&"
export * from "./ToolsAttributesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports